import Icon, { IconType } from 'components/Icon';
import { Tooltip } from 'components/Widget/Tooltip';
import { FrameType } from 'dragonmouse-shared/interfaces';
import { MenuItemAction } from 'menu/MenuItem';
import { useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { selectSceneChatRefs } from 'redux/db/reducers';
import { getSelectedFrameId, openCanvasWidth } from 'redux/mode/util';
import { RootReducer, selectSelectedFrames } from 'redux/reducers';
import { useTheme } from 'styled-components';
import * as S from './styles';
import { ButtonType } from './styles';

const Island = () => {
	const theme = useTheme();
	const [tooltipIdChat] = useState(String(Math.random()));
	const [tooltipIdPrototype] = useState(String(Math.random()));

	const { selectedFrameId, selectedFrames, chatRefs, showLabels, showIsland } = useSelector(
		(r: RootReducer) => {
			return {
				selectedFrameId: getSelectedFrameId(r.mode.selected),
				selectedFrames: selectSelectedFrames(r),
				chatRefs: selectSceneChatRefs(r.db),
				showLabels: openCanvasWidth(r.mode) >= 320,
				showIsland: openCanvasWidth(r.mode) >= 120,
			};
		},
		shallowEqual
	);

	const selectedFrame =
		selectedFrameId && selectedFrames.length === 1
			? selectedFrames.find((f) => f.id === selectedFrameId)
			: null;

	//------------------------------------------------------------------------------------------------
	// HANDLERS
	//------------------------------------------------------------------------------------------------
	const onShowInChatPress = async () => {
		const sourceChatId = selectedFrame?.metadata?.sourceChatId;
		if (selectedFrame && sourceChatId && chatRefs.some((ref) => ref.id === sourceChatId)) {
			MenuItemAction.createScrollToFrameInChat(sourceChatId, selectedFrame.id).callback();
		}
	};

	const onPrototypePress = async () => {
		if (selectedFrameId) {
			MenuItemAction.createOpenPrototype(selectedFrameId).callback();
		}
	};

	//------------------------------------------------------------------------------------------------
	// RENDERING
	//------------------------------------------------------------------------------------------------

	if (!showIsland) return null;
	const sourceChatId = selectedFrame?.metadata?.sourceChatId;
	const canShowInChat =
		selectedFrameId !== null &&
		sourceChatId !== undefined &&
		chatRefs.some((ref) => ref.id === sourceChatId);
	const canOpenPrototype =
		selectedFrameId !== null && selectedFrame?.metadata?.type !== FrameType.IMPORT;
	return (
		<>
			<S.Base>
				<S.Button
					data-tooltip-id={tooltipIdChat}
					data-tooltip-content="Show selected frame in chat"
					onClick={onShowInChatPress}
					active={canShowInChat}
					buttonType={ButtonType.LEFT}
				>
					<S.Icon>
						<Icon
							type={IconType.CHAT}
							width={14}
							height={14}
							color={canShowInChat ? theme.gray[1000] : theme.gray[400]}
						/>
					</S.Icon>
					{showLabels && (
						<S.Label color={canShowInChat ? theme.gray[900] : theme.gray[400]}>Show chat</S.Label>
					)}
				</S.Button>
				<Tooltip id={tooltipIdChat} placement="top" />
				<S.VerticalLine />
				<S.Button
					data-tooltip-id={tooltipIdPrototype}
					data-tooltip-content="View prototype of selected frame"
					onClick={onPrototypePress}
					active={canOpenPrototype}
					buttonType={ButtonType.RIGHT}
				>
					<S.Icon>
						<Icon
							type={IconType.PLAY}
							width={14}
							height={14}
							color={canOpenPrototype ? theme.gray[1000] : theme.gray[400]}
						/>
					</S.Icon>
					{showLabels && (
						<S.Label color={canOpenPrototype ? theme.gray[900] : theme.gray[400]}>
							Prototype
						</S.Label>
					)}
				</S.Button>
				<Tooltip id={tooltipIdPrototype} placement="top" />
			</S.Base>
		</>
	);
};

export default Island;
